<!--
Author: jiangli
Date: 2024-05-08
Desc: 定投计算器
 -->
<template>
    <div>
        <div class="bor_E4E4E4 pl20 pr20 pb20">
            <div class="fs20 c_333 pt16 pb20">定投计算器</div>
            <div class="bor_t_E4E4E4 mb30">
                <el-form
                    ref="planCalculator"
                    :model="fundInfo"
                    :rules="rules"
                    label-position="right"
                >
                    <div class="flex between">
                        <div>
                            <el-form-item label="定投方式：" prop="plantype">
                                <el-radio-group v-model="fundInfo.plantype">
                                    <el-radio label="0">定期定额</el-radio>
                                    <el-radio label="1">定期不定额</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="开始日期：" prop="begindate">
                                <date-picker
                                    :date="dateSet1"
                                    style="width: 400px"
                                    v-on:date-get="dateInterval($event, 'begindate')"
                                />
                            </el-form-item>
                            <el-form-item label="赎回日期：" prop="enddate">
                                <date-picker
                                    :date="dateSet2"
                                    v-on:date-get="dateInterval($event, 'enddate')"
                                />
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '1'"
                                label="指数类型："
                                prop="indextype"
                            >
                                <el-select v-model="fundInfo.indextype">
                                    <el-option
                                        v-for="(item, index) in $cache.getDict('110033')"
                                        :key="index"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '1'"
                                label="均线类型："
                                prop="averagetype"
                            >
                                <el-select v-model="fundInfo.averagetype">
                                    <el-option
                                        v-for="(item, index) in $cache.getDict('210312')"
                                        :key="index"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '1'"
                                label="级差："
                                prop="floatratio"
                            >
                                <el-select v-model="fundInfo.floatratio">
                                    <el-option label="10%" value="0.1"></el-option>
                                    <el-option label="20%" value="0.2"></el-option>
                                    <el-option label="30%" value="0.3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '0'"
                                label="分红方式："
                                prop="defdividendmethod"
                            >
                                <el-radio-group v-model="fundInfo.defdividendmethod">
                                    <el-radio
                                        v-for="(item, index) in $cache.getDict('110001')"
                                        :key="index"
                                        :label="item.subitem"
                                    >
                                        {{ item.subitemname }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="定投基金：" prop="fundcode">
                                <el-select v-model="fundInfo.fundcode" filterable>
                                    <el-option
                                        v-for="(item, index) in funds"
                                        :key="index"
                                        :label="'[' + item.fundcode + ']' + item.fundname"
                                        :value="item.fundcode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="定投金额：" prop="appamount">
                                <el-input v-model="fundInfo.appamount"></el-input>
                            </el-form-item>
                            <div class="flex between w485">
                                <el-form-item label="定投费率：" class="rate" prop="planfee">
                                    <div class="flex hcenter bor_D9D9D9 pt12 pb12 pl13 pr13">
                                        <input
                                            v-model="fundInfo.planfee"
                                            type="number"
                                            class="w36 bor_none c_999 outline_none w103"
                                        />
                                        <span>%</span>
                                    </div>
                                </el-form-item>
                                <el-form-item label="赎回费率：" class="rate" prop="redeemfeee">
                                    <div class="flex hcenter bor_D9D9D9 pt12 pb12 pl13 pr13">
                                        <input
                                            v-model="fundInfo.redeemfeee"
                                            type="number"
                                            class="w36 bor_none c_999 outline_none w103"
                                        />
                                        <span>%</span>
                                    </div>
                                </el-form-item>
                            </div>
                            <el-form-item
                                v-if="fundInfo.plantype === '0'"
                                label="收费方式："
                                prop="transfeetype"
                            >
                                <el-radio-group v-model="fundInfo.transfeetype">
                                    <el-radio label="1">外扣法</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '1'"
                                label="分红方式："
                                prop="defdividendmethod"
                            >
                                <el-radio-group v-model="fundInfo.defdividendmethod">
                                    <el-radio
                                        v-for="(item, index) in $cache.getDict('110001')"
                                        :key="index"
                                        :label="item.subitem"
                                    >
                                        {{ item.subitemname }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '1'"
                                label="购买方式："
                                prop="sharetype"
                            >
                                <el-radio-group v-model="fundInfo.sharetype">
                                    <el-radio
                                        v-for="(item, index) in sharetypeList"
                                        :key="index"
                                        :label="item.subitem"
                                    >
                                        {{ item.subitemname }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '1'"
                                label="净申购额："
                                prop="transfeetype"
                            >
                                <el-radio-group v-model="fundInfo.transfeetype">
                                    <el-radio label="1">外扣法</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <div class="flex">
                    <el-button type="primary" class="medium m-auto" v-on:click="valid">
                        计算收益
                    </el-button>
                </div>
            </div>
            <div v-if="searched" class="bc_FBFBFB pt20 pl20 pr20">
                <!--第一个表格start-->
                <div class="bor_F1F1F1 flex pt18 pb18 c_666666 bc_FCFAE8">
                    <div class="flex1 pl16">投入本金</div>
                    <div class="flex1 txt-c">定投日期</div>
                    <div class="flex1 txt-c">当日净值</div>
                    <div class="flex1 txt-c">购得份额</div>
                    <div class="flex1 txt-c">累计份额</div>
                    <div class="flex1 txt-c">累计收益率</div>
                </div>
                <div v-if="tableData1.length > 0">
                    <div
                        v-for="(item, index) in tableData1"
                        :key="index"
                        class="flex c_666666 pt27 pb27 bc_ffffff bor_b_F1F1F1"
                    >
                        <div class="flex1 pl16">{{ $util.fmtNum(item.amount) || "--" }}</div>
                        <div class="flex1 txt-c">{{ $util.fmtDate(item.plandate) || "--" }}</div>
                        <div class="flex1 txt-c">{{ $util.fmtNum(item.nav, 4) || "--" }}</div>
                        <div class="flex1 txt-c">{{ $util.fmtNum(item.confirmvol) || "--" }}</div>
                        <div class="flex1 txt-c">{{ $util.fmtNum(item.totalvol) || "--" }}</div>
                        <div class="flex1 txt-c">
                            {{ $util.fmtNum(item.floatratio, 4) || "--" }}
                        </div>
                    </div>
                </div>
                <div v-else class="pt27 pb27 txt-c bc_ffffff bor_F1F1F1 c_999">
                    目前还没有，晚点再看看
                </div>
                <div class="bc_ffffff bor_F1F1F1 flex txt-c">
                    <div class="flex1 bor_r_F1F1F1 pt16 pb16">
                        <div class="c_999">扣款次数</div>
                        <div class="fs18 mt8 bold">{{ calInfo.totaltimes || "--" }}</div>
                    </div>
                    <div class="flex1 bor_r_F1F1F1 pt16 pb16">
                        <div class="c_999">累计投入金额(元)</div>
                        <div class="fs18 mt8 c_EA0000">
                            {{ $util.fmtNum(calInfo.totalamount) || "--" }}
                        </div>
                    </div>
                    <div class="flex1 pt16 pb16">
                        <div class="c_999">平均成本(元)</div>
                        <div class="fs18 mt8 c_EA0000">
                            {{ $util.fmtNum(calInfo.avgcostmoney, 4) || "--" }}
                        </div>
                    </div>
                </div>
                <!--第一个表格end-->

                <!--第二个表格start-->
                <div class="flex hcenter mt40 mb20">
                    <div class="w3-7r h16 bc_E60012 mr6"></div>
                    <div class="fs18">赎回汇总</div>
                </div>
                <div class="bor_F1F1F1 flex pt18 pb18 c_666666">
                    <div class="flex1 pl16">当日市值(元)</div>
                    <div class="flex1 txt-c">赎回日期</div>
                    <div class="flex1 txt-c">赎回价格(元)</div>
                    <div class="flex1 txt-c">购得份额(份)</div>
                    <div class="flex1 txt-c">赎回费用(元)</div>
                </div>
                <div class="bor_F1F1F1 flex c_666666 pt27 pb27 bc_ffffff">
                    <div class="flex1 pl16">{{ $util.fmtNum(calInfo.redeemmarket) || "--" }}</div>
                    <div class="flex1 txt-c">{{ $util.fmtDate(calInfo.redeemdate) || "--" }}</div>
                    <div class="flex1 txt-c">
                        {{ $util.fmtNum(calInfo.redeemprice, 4) || "--" }}
                    </div>
                    <div class="flex1 txt-c">
                        {{ $util.fmtNum(calInfo.redeemconfirmvol) || "--" }}
                    </div>
                    <div class="flex1 txt-c">{{ $util.fmtNum(calInfo.redeemcharge) || "--" }}</div>
                </div>
                <!--第二个表格end-->

                <!--第三个表格start-->
                <div class="flex hcenter mt40 mb20">
                    <div class="w3-7r h16 bc_E60012 mr6"></div>
                    <div class="fs18">收益汇总</div>
                </div>
                <div class="bor_F1F1F1 flex pt18 pb18 c_666666">
                    <div class="flex1 pl16">赎回所得(元)</div>
                    <div class="flex1 txt-c">累计红利(元)</div>
                    <div class="flex1 txt-c">累计转投(元)</div>
                    <div class="flex1 txt-c">定投总收益(份)</div>
                    <div class="flex1 txt-c">定投总收益率</div>
                </div>
                <div class="bor_F1F1F1 flex c_666666 pt27 pb27 bc_ffffff">
                    <div class="flex1 pl16">{{ $util.fmtNum(calInfo.redeemprice) || "--" }}</div>
                    <div class="flex1 txt-c">{{ $util.fmtNum(calInfo.totaldividend) || "--" }}</div>
                    <div class="flex1 txt-c">
                        {{ $util.fmtNum(calInfo.totaldividendvol) || "--" }}
                    </div>
                    <div class="flex1 txt-c">{{ $util.fmtNum(calInfo.totalprofit) || "--" }}</div>
                    <div class="flex1 txt-c">
                        {{ $util.fmtNum(calInfo.totalincomeratio, 4) || "--" }}
                    </div>
                </div>
                <!--第三个表格end-->

                <!--第四个表格start-->
                <div class="flex hcenter mt40 mb20">
                    <div class="w3-7r h16 bc_E60012 mr6"></div>
                    <div class="fs18">分红拆分明细</div>
                </div>
                <div class="bor_F1F1F1 flex pt18 pb18 c_666666">
                    <div class="flex1 pl16">日期</div>
                    <div class="flex1 txt-c">分红或拆分比例</div>
                    <div class="flex1 txt-c">参与份额(份)</div>
                    <div class="flex1 txt-c">现金分红(元)</div>
                    <div class="flex1 txt-c">转投(份)</div>
                </div>
                <div v-if="tableData2.length > 0">
                    <div
                        v-for="(item, index) in tableData2"
                        :key="index"
                        class="flex c_666666 pt27 pb27 bc_ffffff bor_b_F1F1F1"
                    >
                        <div class="flex1 pl16">{{ $util.fmtDate(item.dividenddate) || "--" }}</div>
                        <div class="flex1 txt-c">{{ $util.fmtNum(item.dividendunit) || "--" }}</div>
                        <div class="flex1 txt-c">{{ $util.fmtNum(item.dividendvol) || "--" }}</div>
                        <div class="flex1 txt-c">
                            {{ $util.fmtNum(item.dividendamount) || "--" }}
                        </div>
                        <div class="flex1 txt-c">
                            {{ $util.fmtNum(item.dividendbuyvol) || "--" }}
                        </div>
                    </div>
                </div>
                <div v-else class="pt27 pb27 txt-c bc_ffffff bor_F1F1F1 c_999 flex wcenter">
                    <div class="flex hcenter">
                        <img src="../../assets/img/red-tip.png" class="w16 h16 mr3" />
                        <div class="c_EA0000">未查询到符合条件的数据！</div>
                    </div>
                </div>
                <!--第四个表格end-->

                <div class="flex wcenter mt30">
                    <div
                        class="c_ffffff bc_E60012 pt10 pb10 pl42 pr42 fs16 mb40 pointer"
                        v-on:click="$router.push('gfund/glist')"
                    >
                        立即办理定投
                    </div>
                </div>
            </div>
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
            class="pl20"
        ></footerQuestions>
    </div>
</template>

<script>
import footerQuestions from "@/components/layout/footerQuestions.vue";
import datePicker from "@/components/form/datePicker";
import fundApi from "@/api/fund";
import warningHtml from "@/constant/warning_html.js";
import format from "date-fns/format";
export default {
    name: "PlanCalculator",
    components: { footerQuestions, datePicker },
    data() {
        return {
            fundInfo: {
                // 入参信息
                plantype: "0",
                begindate: "",
                enddate: "",
                defdividendmethod: "1",
                fundcode: "",
                appamount: "",
                planfee: "",
                redeemfeee: "",
                sharetype: "0",
                indextype: "",
                averagetype: "",
                floatratio: "",
                transfeetype: "1"
            },
            rules: {
                plantype: [{ required: true, message: "请选择定投方式", trigger: "blur" }],
                begindate: [{ required: true, message: "请选择开始日期", trigger: "blur" }],
                enddate: [{ required: true, message: "请选择赎回日期", trigger: "blur" }],
                defdividendmethod: [{ required: true, message: "请选择分红方式", trigger: "blur" }],
                fundcode: [{ required: true, message: "请选择定投基金", trigger: "blur" }],
                appamount: [{ required: true, message: "请输入定投金额", trigger: "blur" }],
                planfee: [
                    { required: true, message: "请输入定投费率", trigger: "blur" },
                    { validator: this.validRatio, trigger: "blur" }
                ],
                redeemfeee: [
                    { required: true, message: "请输入赎回费率", trigger: "blur" },
                    { validator: this.validRatio, trigger: "blur" }
                ],
                indextype: [{ required: true, message: "请选择指数类型", trigger: "blur" }],
                averagetype: [{ required: true, message: "请选择均线类型", trigger: "blur" }],
                floatratio: [{ required: true, message: "请选择级差", trigger: "blur" }],
                transfeetype: [{ required: true, message: "请选择净申购额", trigger: "blur" }]
            },
            dateSet1: { type: "", min: "1990-01-01" },
            dateSet2: { type: "", min: "1990-01-01" },
            funds: [],
            commonQuestion: [],
            warningHtml: "",
            tableData1: [],
            tableData2: [],
            calInfo: {},
            searched: false,
            sharetypeList: []
        };
    },
    watch: {
        "fundInfo.planfee"(val) {
            this.$refs["planCalculator"].validateField("planfee");
        },
        "fundInfo.redeemfeee"(val) {
            this.$refs["planCalculator"].validateField("redeemfeee");
        }
    },
    created() {
        // 收费方式过滤掉前后收费
        this.sharetypeList = this.$cache.getDict("130000").filter((item) => {
            return item.subitem != "2";
        });
        this.warningHtml = warningHtml.warningHtml6;
        this.commonQuestion = this.$const.commonQuestion.commonQuestion6;
        // 获取定投基金
        this.getFunds();
        // 初始化值
        this.initializeValue();
    },

    methods: {
        initializeValue() {
            // 设置开始时间和赎回时间
            var maxDate = new Date();
            var maxDate1 = new Date();
            maxDate1.setDate(maxDate1.getDate() - 1000);
            maxDate.setDate(maxDate1.getDate() - 100);
            let begindate = format(maxDate1.setDate(maxDate1.getDate() - 1000), "YYYY-MM-DD");
            let enddate = format(maxDate.setDate(maxDate1.getDate() - 100), "YYYY-MM-DD");
            this.dateSet1.val = begindate;
            this.dateSet2.val = enddate;
            this.dateInterval(begindate, "begindate");
            this.dateInterval(enddate, "enddate");
            // 初始化定投费率和赎回费率
            this.fundInfo.planfee = "0.6";
            this.fundInfo.redeemfeee = "0.5";
            // 初始化指数类型 均线类型 级差
            this.fundInfo.indextype = "a";
            this.fundInfo.averagetype = "01";
            this.fundInfo.floatratio = "0.1";
        },
        validRatio(rule, value, callback) {
            if (Number(value) < 0 || Number(value) > 100) {
                callback(new Error("输入费率应为0-100之间"));
            } else {
                callback();
            }
        },
        async getFunds() {
            const _x = {
                pagesize: 999,
                pagenum: 1,
                valuagrbuystate: "1",
                tradingmethod: this.$util.getConfig().systemtype
            };
            const res = await fundApi.getFundLists(_x);
            if (res.data) {
                this.funds = res.data.list;
                this.fundInfo.fundcode = res.data.list[0].fundcode;
            }
        },
        // 方法定义
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },
        dateInterval(val, key) {
            this.fundInfo[key] = val !== null ? val.replace(/-/g, "") : "";
        },
        async valid() {
            //            this.searched = true; // 临时代码
            //            return; // 临时代码
            this.$refs["planCalculator"].validate((valid) => {
                if (valid) {
                    this.searched = true;
                    this.doCalculate();
                }
            });
        },
        async doCalculate() {
            let data = JSON.parse(JSON.stringify(this.fundInfo));
            data.planfee = data.planfee / 100 + "";
            data.redeemfeee = data.redeemfeee / 100 + "";
            const res = await fundApi.combCalPlanModle(data);
            console.log("res", res);
            this.tableData1 = res.data.plandetailvolist;
            this.tableData2 = res.data.detailvolist;
            this.calInfo = res.data;
        }
    }
};
</script>

<style lang="scss" scoped>
.el-form {
    padding: 48px 67px 41px 87px;
    .el-form-item {
        display: flex;
    }
    :deep(.el-date-editor) {
        width: 400px !important;
    }
    :deep(.el-form-item__label) {
        padding-right: 0 !important;
    }
    .rate {
        :deep(.el-form-item__content) {
            width: auto !important;
            line-height: normal !important;
        }
    }
    :deep(.el-form-item__content) {
        width: 400px !important;
    }
    :deep(.el-select) {
        width: 400px !important;
    }
    :deep(.el-form-item__error) {
        width: 100% !important;
    }
}
.common-question-contain {
    margin: 20px 0;
}
</style>
